const LEGAL = {
  privacy: {
    title: "Privacy Policy",
    body: [
      ["Overview", "Amden One is GDPR-conscious. We only collect the data needed to run your business workspace, and you stay in control of it."],
      ["What we store", "Your account details, business information, and the records you create (customers, quotes, invoices, jobs and files). Each business's data is strictly isolated."],
      ["How we use it", "To provide the service, generate documents, and send the notifications you configure. We never sell your data."],
      ["Your rights", "You can request a data export or account deletion at any time from your settings, or by contacting us."],
      ["Security", "Data is encrypted in transit. Access is role-based and server-enforced, with an audit trail for sensitive actions."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      ["Agreement", "By creating an Amden One account you agree to use the platform lawfully and to keep your login secure."],
      ["Subscriptions", "Each business workspace has one subscription. Plans (Free, Basic, Full) determine which features are available."],
      ["Acceptable use", "You are responsible for the content you create and for complying with tax and accounting obligations in your jurisdiction."],
      ["VAT & accounting", "Reports and VAT summaries are estimates to help you stay organised and are not a substitute for professional accounting advice."],
      ["Changes", "We may update these terms and the service over time. Continued use means you accept the current terms."],
    ],
  },
};

export default function Legal({ page }) {
  const c = LEGAL[page] || LEGAL.privacy;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
      <h1 className="text-4xl font-extrabold tracking-tight text-navy">{c.title}</h1>
      <p className="mt-2 text-sm text-slate-500">Last updated {new Date().toLocaleDateString("en-GB", { month: "long", year: "numeric" })}</p>
      <div className="mt-10 space-y-8">
        {c.body.map(([t, d]) => (
          <section key={t}>
            <h2 className="font-display text-xl font-semibold text-navy">{t}</h2>
            <p className="mt-2 text-slate-600 leading-relaxed">{d}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
